module.exports = __webpack_public_path__ + "img/links.2ce9e078.svg";